module.exports = __webpack_public_path__ + "static/media/三杯杏鮑菇.608a4c3c.jpg";